// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__L0FWB"};